const ALPHABET = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

/**
 * Short, URL-safe random id (≈71 bits), e.g. `itm_3fK9x0LqZr2B`. Ids only need to be unique within
 * a project/user, and must match the model's id pattern ([A-Za-z0-9_-]).
 */
export function newId(prefix: string, length = 12): string {
  const bytes = crypto.getRandomValues(new Uint8Array(length));
  let id = '';
  for (const byte of bytes) id += ALPHABET.charAt(byte % ALPHABET.length);
  return `${prefix}_${id}`;
}
